/* eslint-disable prefer-destructuring */
import { mappingCompanySlugToName } from '@/utils/airlineMapping';
import { pr } from '@/utils/pxToRem';
import { Link, Stack } from '@mui/material';
import React from 'react';

const listCompany = ['vietnam-airlines', 'vietjet-air', 'bamboo-airways', 'vietravel-airlines', 'pacific-airlines'];

interface SectionOtherCompanyProps {
  companySlug: string;
  isDesktop?: boolean;
}

const mappingAirlineToCode = (airline: string) => {
  switch (airline) {
    case 'vietnam-airlines':
      return 'VN';
    case 'vietjet-air':
      return 'VJ';
    case 'bamboo-airways':
      return 'QH';
    case 'vietravel-airlines':
      return 'VU';
    case 'pacific-airlines':
      return 'BL';
    default:
      return 'VN';
  }
};

const SectionAirline: React.FC<SectionOtherCompanyProps> = ({
  companySlug, isDesktop,
}) => {
  const otherCompany = listCompany.filter((item) => item !== companySlug);

  return (
    <Stack
      spacing={isDesktop ? '0px' : pr`8px`}
      direction={isDesktop ? 'row' : 'column'}
      justifyContent="space-between"
      marginTop={pr`16px`}
    >
      {otherCompany.map((com) => (
        <Stack
          spacing={pr`8px`}
          direction="row"
          key={com}
        >
          <img
            style={{ borderRadius: '50%' }}
            src={`https://storage.googleapis.com/goyolo-uat/images/airlines/${
              mappingAirlineToCode(com).toLowerCase() || 'vn'
            }.png`}
            alt=""
            width="22"
            height="22"
            className="lazyload"
          />
          <Link
            sx={{
              fontWeight: 500,
              textDecoration: 'none',
            }}
            href={`/vn/ve-may-bay/${com}.vi`}
            key={com}
          >
            {` Hãng hàng không ${mappingCompanySlugToName(com)}
            `}
          </Link>
        </Stack>
      ))}
    </Stack>
  );
};

export default SectionAirline;
